export default __webpack_public_path__ + "static/media/googlePlayRes.9675ba14.svg";